import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "children", "orientation", "revertControls", "highlightChanges", "gutter", "collapseUnchanged", "renderRevertControl"],
  _excluded2 = ["modified", "modifiedExtension", "original", "originalExtension", "theme", "view", "dispatch"];
import React, { useEffect, useImperativeHandle, useRef } from 'react';
import { getDefaultExtensions } from '@uiw/react-codemirror';
import { MergeView } from '@codemirror/merge';
import { useStore } from './store';
import { jsx as _jsx } from "react/jsx-runtime";
export var Internal = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      className,
      children,
      orientation,
      revertControls,
      highlightChanges,
      gutter,
      collapseUnchanged,
      renderRevertControl
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _useStore = useStore(),
    {
      modified,
      modifiedExtension,
      original,
      originalExtension,
      theme,
      view,
      dispatch
    } = _useStore,
    otherStore = _objectWithoutPropertiesLoose(_useStore, _excluded2);
  var editor = useRef(null);
  var opts = {
    orientation,
    revertControls,
    highlightChanges,
    gutter,
    collapseUnchanged,
    renderRevertControl
  };
  useImperativeHandle(ref, () => ({
    container: editor.current,
    view,
    modified,
    original,
    config: _extends({
      a: original,
      b: modified,
      parent: editor.current
    }, opts)
  }), [editor, view, modified, original, opts]);
  useEffect(() => {
    if (view && original && modified && theme && editor.current && dispatch) {
      editor.current.innerHTML = '';
      new MergeView(_extends({
        a: _extends({}, original, {
          extensions: [...(originalExtension || []), ...getDefaultExtensions({
            theme: theme
          })]
        }),
        b: _extends({}, modified, {
          extensions: [...(modifiedExtension || []), ...getDefaultExtensions({
            theme: theme
          })]
        }),
        parent: editor.current
      }, opts));
    }
  }, [theme, editor.current, original, modified, originalExtension, modifiedExtension]);
  useEffect(() => {
    if (!view && editor.current && original != null && original.extensions && modified != null && modified.extensions) {
      var viewDefault = new MergeView(_extends({
        a: original,
        b: modified,
        parent: editor.current
      }, opts));
      dispatch && dispatch(_extends({
        view: viewDefault,
        container: editor.current
      }, opts));
    }
  }, [editor.current, original, modified, view]);
  useEffect(() => () => view && view.destroy(), []);
  useEffect(() => {
    if (view) {
      var _opts = {};
      if (otherStore.orientation !== orientation) {
        _opts.orientation = orientation;
      }
      if (otherStore.revertControls !== revertControls) {
        _opts.revertControls = revertControls;
      }
      if (otherStore.highlightChanges !== highlightChanges) {
        _opts.highlightChanges = highlightChanges;
      }
      if (otherStore.gutter !== gutter) {
        _opts.gutter = gutter;
      }
      if (otherStore.collapseUnchanged !== collapseUnchanged) {
        _opts.collapseUnchanged = collapseUnchanged;
      }
      if (Object.keys(_opts).length && dispatch && original && modified && editor.current) {
        view.destroy();
        var viewDefault = new MergeView(_extends({
          a: original,
          b: modified,
          parent: editor.current
        }, _opts));
        dispatch(_extends({}, _opts, {
          renderRevertControl,
          view: viewDefault
        }));
      }
    }
  }, [view, original, modified, editor, orientation, revertControls, highlightChanges, gutter, collapseUnchanged, renderRevertControl]);
  var defaultClassNames = 'cm-merge-theme';
  return /*#__PURE__*/_jsx("div", _extends({
    ref: editor,
    className: "" + defaultClassNames + (className ? " " + className : '')
  }, elmProps, {
    children: children
  }));
});
Internal.displayName = 'CodeMirrorMerge.Internal';